import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=9a64c13a&scoped=true"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"
import style0 from "./Action.vue?vue&type=style&index=0&id=9a64c13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a64c13a",
  null
  
)

export default component.exports